import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { TranslateContext } from '@shared/pipes/translate.pipe';


@Component({
	selector: 'amd-au-confirm-working-action-dialog',
	templateUrl: './au-confirm-working-action-dialog.component.html',
	styleUrls: ['./au-confirm-working-action-dialog.component.scss']
})
export class AuConfirmWorkingActionDialogComponent {

	text: string;
	isClosing: boolean;
	translateContext: TranslateContext = TranslateContext.AUTHORITY;

	constructor(@Inject(MAT_DIALOG_DATA) private data: { text: string },
				private dialogRef: MatDialogRef<AuConfirmWorkingActionDialogComponent>) {
		this.text = this.data.text;
	}

	confirmAction(confirm: boolean): void {
		this.isClosing = true;
		this.dialogRef.close(confirm);
	}

}
